import jsPDF from 'jspdf';
import 'jspdf-autotable';

interface PrintableColumn {
  header: string;
  key: string;
}

interface Node {
  dbId?: number;
  id?: number;
  [key: string]: any;
}

interface DataItem {
  node: Node;
  [key: string]: any;
}


const generatePDF = (selectedItems: number[], data: DataItem[], printableColumn: PrintableColumn[]) => {
  const filteredData = data.filter(item => {
    const id = item?.node?.dbId || item.id;
    return id !== undefined && selectedItems.includes(id);
  });

  const printableData = filteredData.map(item => {
    return printableColumn.map(col => {
      const keys = col.key.split('.');
      let value: any = item;
      for (const key of keys) {
        value = value[key];
        if (value === undefined) break;
      }
      return value !== undefined ? value : '';
    });
  });

  const doc = new jsPDF();
  const headers = printableColumn.map(col => col.header);

  (doc as any).autoTable({
    head: [headers],
    body: printableData,
  });

  // Convert to Blob and create Blob URL
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);

  console.log("Blob URL created:", blobUrl); // Log when created

  // Open in new window for print preview
  const newWindow = window.open(blobUrl, '_blank');

  // Cleanup: Revoke Blob URL when window is closed otherwise it will remain in memory and slow down the computer
  if (newWindow) {
    newWindow.onload = () => {
      URL.revokeObjectURL(blobUrl);
      console.log("Blob URL revoked:", blobUrl); // Confirm revocation
    };
  }
};

export default generatePDF;
